/**
 * Display names for scene and catalog enums. Admin can't import the web app, so
 * these mirror it:
 *   - HANGAR_TYPE_LABEL   ← apps/web/src/config/hangarTypeIcons.ts
 *   - STRUCTURE_PRESET_LABEL ← the preset `label`s in apps/web/src/lib/structures/presets.ts
 *   - SHAPE_LABEL          ← the shape palette in apps/web/src/components/editor/left-panel/BuildingsPanel.tsx
 * Labels only — a stale one reads oddly but gates nothing (tiers live in tierLadder.ts).
 */

import type { AircraftClass, BuildingType, ProceduralShape, StructurePresetId } from '@hangarmax/types'

export const HANGAR_TYPE_LABEL: Record<BuildingType, string> = {
  box: 'Box Hangar',
  t_hangar: 'T-Hangar',
  arch_hangar: 'Arch Hangar',
  single_row: 'Hangars Row',
  standard_t_hangar: 'T-Hangar Row',
  nested_t_hangar: 'Nested T-Hangar Row',
}

export const STRUCTURE_PRESET_LABEL: Record<StructurePresetId, string> = {
  office: 'Office Building',
  warehouse: 'Warehouse',
  mro: 'MRO Shop',
  fire_station: 'Fire Station',
  gatehouse: 'Gatehouse',
  gse_garage: 'GSE Garage',
  utility_building: 'Utility Building',
  deicing_station: 'De-Icing Station',
  fbo: 'FBO Terminal',
  regional_terminal: 'Regional Terminal',
  shade_port: 'Shade Port',
  covered_walkway: 'Covered Walkway',
  parking_canopy: 'Parking Canopy',
}

export const SHAPE_LABEL: Record<ProceduralShape, string> = {
  box: 'Box',
  cylinder: 'Cylinder',
  cone: 'Cone',
  pyramid: 'Pyramid',
  sphere: 'Sphere',
  hemisphere: 'Hemisphere',
  ramp: 'Ramp',
  jetway: 'Jet Bridge',
  atc_tower: 'Control Tower',
  fuel_tank_vertical: 'Fuel Tank (Vertical)',
  fuel_tank_horizontal: 'Fuel Tank (Horizontal)',
  custom: 'Custom',
}

/** Ladder order — the same order as CLASS_TIER. */
export const AIRCRAFT_CLASSES: AircraftClass[] = [
  'piston', 'rotorcraft_light', 'turboprop_single',
  'turboprop_multi', 'light_jet', 'midsize_jet',
  'large_cabin', 'rotorcraft_heavy', 'airliner',
]

export const AIRCRAFT_CLASS_LABEL: Record<AircraftClass, string> = {
  piston: 'Piston',
  rotorcraft_light: 'Light rotorcraft',
  turboprop_single: 'Single-engine turboprop',
  turboprop_multi: 'Twin turboprop',
  light_jet: 'Light jet',
  midsize_jet: 'Midsize jet',
  large_cabin: 'Large-cabin jet',
  rotorcraft_heavy: 'Heavy rotorcraft',
  airliner: 'Airliner',
}
